import $ from 'jquery';
import './size-selection';
import './ab-3336-view-more-cta';
import heartProduct from "modules/heart-product";
import setUpBisAndSo from "../pdp/bis-and-so";
import manageRefineMenu from './manage-refine-menu';
import initColorSwatches from "./plpswatches";
import initMyFavorites from './my-favorite';
import { checkAndHideZeroReviewElements } from './utils';
import yotpoLazyLoad from './yotpo-lazyload';
import { addToBagWithData } from "modules/add-to-bag";
import initSidePanel from 'modules/side-panel-init';
import "./add-to-bag"; // required for plpAddToBag method
import { revieveTryOn, revieveAddToBag } from '../../modules/revieve-try-on';
import { revieveMakeupAdvisor } from "../../modules/revieve-makeup-advisor";
import initCplBanner from './cpl-banner';
import { renderPlpSocialProof } from "modules/social-proof";
import './loyalty-favorites';
import throttle from 'lodash/throttle';


window.setupBisAndSo = setUpBisAndSo;
window.addToBagWithData = (data, callbacks, addToBagUrl) => {
    if (data.fromZelig) {
        callbacks = {};
        callbacks.success = () => {
            insertPageTrackForMobileWithData({
                addToCartFlag: true,
                productCode: data.code,
                isZeligAddToBag: true
            });
        };
    }
    addToBagWithData(data, callbacks, addToBagUrl);
};

function bindHeartItems(container) {
    if(typeof container === "undefined"){
        heartProduct('.js-page-items', '.fav-item');
    }else{
        heartProduct(container, '.fav-item');
    }
}

function closeLimitLightBox(elemId) {
    $('#' + elemId).removeClass('u-block');
}

function clearOldFavItems() {
    $.ajax({
        type: 'GET',
        url: '/r/ajaxHeartProduct.jsp?action_T=clearolditems',
        success: function () {
            location.reload();
        }
    });
}

function getQueryParamValues(url, param) {
    var result = [];
    if(url) {
        var paramsAndValues = url.slice(url.indexOf('?') + 1).split('&');
        for (var i = 0; i < paramsAndValues.length; i++) {
            if(paramsAndValues[i]) {
                var paramAndValue = paramsAndValues[i].split('=');
                if(2 == paramAndValue.length && (param == paramAndValue[0]) && paramAndValue[1]) {
                    // Inverse of $.param, which is used in getFilterParams
                    var value = decodeURIComponent(paramAndValue[1].replace(/\+/g, ' '));
                    result.push(value);
                }
            }
        }
    }
    return result;
}

function loadShopMoreSection(){
    const relatedProductsDiv = $('#relatedProductsLazyLoadDiv');
    if(relatedProductsDiv.length && typeof window.rcProps.shopMoreProductsURL !== "undefined"){
        $('#plp-prod-list').parent().addClass("u-border-b u-margin-b--xxl u-border--xs u-border--color-lighter");
        const listname = relatedProductsDiv.data("listName");
        const numberOFProductsToLoad = relatedProductsDiv.data("productCount");
        const pageNum = relatedProductsDiv.data("pageNumber");
        const cplid = relatedProductsDiv.data("cplId");
        const data = "listname="+listname+"&numberOfProducts="+numberOFProductsToLoad+"&pageNum="+pageNum + "&cplId="+cplid;
        $.ajax({
            url: window.rcProps.shopMoreProductsURL,
            type: 'POST',
            data: data,
            success: function(markup) {
                relatedProductsDiv.append(markup);
                relatedProductsDiv.find('.js-lazy-image').lazy({
                    effect: 'fadeIn',
                    effectTime: 300,});
                bindHeartItems(relatedProductsDiv);
                initColorSwatches();
                loadPagination();
            }
        });
    }
}

function bindSimilarItemsExpansion() {
    $('.js-similar-item').click(function(e) {
        e.preventDefault();
        $.modal({
            url: "/r/mobile/dialog/SimilarItemsView.jsp?d=" + $(this).data("department"),
            data : {
                code: $(this).data("pcode")
            },
            type: "toast",
            triggerOpen: true,
            onLoad: function() {
                $('.modal__content').css('padding-right', '0');
            },
            onClose: function() {
                $('.modal__content').css('padding-right', '16');
            }
        });
    });
}

// Methods to set, add, and remove Progress Bar for slow connections
function appendModalProgressBar() {
  if (!$('.modal-overlay').length) {
    $('<div class="modal-overlay"></div>').appendTo('body');
  }
  if (!$('.modal-overlay__progress-bar').length) {
    $(`<div class="modal-overlay__progress-bar modal-overlay__progress-bar--hidden progress-bar progress-bar--center" tabindex="-1">
        <div class="u-screen-reader">
            Content is Loading.
        </div>
     </div>`).appendTo('.modal-overlay');
  }
  return;
}

function activateModalProgressBar() {
  $('.modal-overlay').addClass('is-active');
  $('.modal-overlay__progress-bar').removeClass('modal-overlay__progress-bar--hidden');
  $('body').addClass('body--modal-overflow-hidden');
  return;
}

function deactivateModalProgressBar() {
  $('body').removeClass('body--modal-overflow-hidden');
  $('.modal-overlay__progress-bar').addClass('modal-overlay__progress-bar--hidden');
  $('.modal-overlay').removeClass('is-active');
  return;
}

// add to bag plp select size
function loadSizeMenu(code) {
    appendModalProgressBar();
    activateModalProgressBar();
    var sizeContent = $('#add-to-bag-' + code).html();
    if (sizeContent.indexOf('fixed-overlay__item') >= 0) {
        //Remove the modal overlay and progress bar
        deactivateModalProgressBar();
        //Remove the ability to scroll main content while overlay is present
        $('body').css({'overflow-y': 'hidden'});
        $('#size-menu-' + code).addClass("fixed-overlay__scroll--active");
        return;
    }
    $.ajax({
        type: "GET",
        url: "/r/ajax/GetProductSizeMenu.jsp?code=" + code,
        success: function (rtn) {
            $(".js-size-menu-container").each(function(){
                if($(this).hasClass('fixed-overlay__container')){
                    $(this).empty();
                }
            });
            $('#add-to-bag-' + code).html(rtn);
            //Remove the modal overlay and progress bar
            deactivateModalProgressBar();
            //Remove the ability to scroll main content while overlay is present
            $('body').css({'overflow-y': 'hidden'});
            $('#size-menu-' + code).addClass("fixed-overlay__scroll--active");
        }
    });
}

  /*
   * Favorites PLP - delete favorite list
   */

  /*
  * PLP Pagination Dropdown AB Test
  */
function loadPagination() {
    $('.pagination__dropdown-ab-test').on('click', function (e) {
        e.stopPropagation();
        $('.pagination__dropdown-content-ab-test').toggleClass('u-block');
        $('.pagination__dropdown-ab-test').toggleClass('u-border--black');
    })
}

document.documentElement.addEventListener('click', () => {
    const dropdownMenu = document.getElementsByClassName('pagination__dropdown-ab-test');
    if (dropdownMenu.length > 0 && dropdownMenu[0].classList.contains('u-border--black')) {
        $('.pagination__dropdown-content-ab-test').toggleClass('u-block');
        $('.pagination__dropdown-ab-test').toggleClass('u-border--black');
    }
})

function closeSizeMenu(code) {
    //Add back the ability to scroll main content when overlay is closed
    $('body').css({'overflow-y': 'auto'});

    $('#size-menu-' + code).removeClass("fixed-overlay__scroll--active");
}

function openNotifyMeModal() {
    const data = $.param({
        code: $(this).data('code'),
        size: $(this).data("sizeSelected")
    });

    $.modal({
        url: window.rcProps.backInStockSpecialOrderHref,
        data: data,
        type: "toast",
        open: null,
        cache: false,
        overlayClose: true,
        triggerOpen: true,
        onComplete: function () {
            $(".js-tabs").tabs();
        }
    });
}
// Mock Content Start - UX-17928
window.bindSizeGuideEvent = function() {
    $('.js-size-guide-modal').on('click', function() {
        if ($(this).data('fitPredictorCode') && $(this).data('showDynamicSizeGuide')) {
            ssp('start', 'sizeguide');
            ssp('track', 'triggerSizeGuide', {
                productId: $(this).data('fitPredictorCode'),
                origin: 'sizeguide-cta'
            });
        }

        $.modal({
            url: `${$(this).data('url')}`,
            triggerOpen: true,
            type: 'full',
        })
    });

    $('.view_size_guide').click(function () {
        logEngagement('Size Guide Link', 'Click');
    });
};

yotpoLazyLoad();
document.addEventListener("DOMContentLoaded", function() {
    // Create the observer with the throttled callback
    const observer = new MutationObserver(throttle(function(mutationsList, observer) {
      checkAndHideZeroReviewElements();
    }, 20));

    // Start observing with appropriate options
    observer.observe(document.body, { childList: true, subtree: true });

    // Initial check
    checkAndHideZeroReviewElements();
});
// Mock Content End
$(document).ready(function() {
$('.js-lazy-video').each(function() {
    this.play();
    });
const $nav = $('.js-horizontal-scroll-preserve');
$nav.horizontalScroll({
    preserveScrollPosition: true,
    preserveScrollKey: $nav.data('preserve-scroll-key'),
});
$('.js-select-size').sizeSelection();
$('.js-plp-add-to-bag').plpAddToBag();
  manageRefineMenu();
  bindHeartItems();
  initColorSwatches();
  initMyFavorites();
  loadShopMoreSection();
  bindSimilarItemsExpansion();
  loadPagination();
  window.closeLimitLightBox = closeLimitLightBox;
  window.clearOldFavItems = clearOldFavItems;
  window.bindHeartItems = bindHeartItems;
  window.initColorSwatches = initColorSwatches;
  window.loadShopMoreSection = loadShopMoreSection;
  window.bindSimilarItemsExpansion = bindSimilarItemsExpansion;
  window.loadSizeMenu = loadSizeMenu;
  window.closeSizeMenu = closeSizeMenu;
  window.loadPagination = loadPagination;
  window.bindSizeGuideEvent();

  //initSearch();

    // setupToggleCategoryDropdown();
    // resetFilters();
    // processSorting();
    // bindBrandsURl();

    //scroll to product after login
    var scrollToCode = getQueryParamValues(location.href, "scroll");
    var $loadDnde = $('#loadDnde');
    if(scrollToCode && scrollToCode.length > 0 && ($loadDnde.length === 0 || $loadDnde.val() === 'false')){
        var productCode = scrollToCode[0];
        $(window).scrollTop($('.fav-item[data-pcode="' + productCode + '"]').offset().top -50);
    }

    $('.js-notify-me').on('click', openNotifyMeModal);

    initSidePanel();

    // UX-13654 - Rich Nav - Start
    function richNav() {

        const body = document.body;
        const content = document.getElementById('content');
        const navSidePageWrapper = document.getElementById('nav-side-page-wrapper');
        const plpProductsContents = document.getElementById('plp-products-contents');
        if($(plpProductsContents).length) {
          const plpProductsContentsOffsetTop = plpProductsContents.offsetTop;
        }
        const stickyButtons = document.querySelector(".js-sticky-buttons");

        // Keep track of how far the client has scrolled
        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
        });

        $(document).on('click', '.js-nav-side__overlay', function() {
            closeRichNav();
        });

        $('.js-nav-open').on('click', showRichNav);

        // Rich Nav is Closed
        function closeRichNav(){
            const scrollY = body.style.top;
            navSidePageWrapper.classList.remove('nav__sidebar--open');
            body.style.position = 'static';
            body.style.top = '';
            body.style.overflow = '';

            window.scrollTo(0, parseInt(scrollY || '0') * -1);

            // Check if Sticky Buttons and the ID plp-products-contents exist
            if($(stickyButtons).length && $(plpProductsContents).length) {
              if(parseInt(scrollY || '0') * -1 > plpProductsContentsOffsetTop) {
                  stickyButtons.classList.remove('persisitScrolled');
              }
            }
        }

        // Rich Nav is Open
        function showRichNav(){
            const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
            navSidePageWrapper.classList.add('nav__sidebar--open');
            body.style.position = 'fixed';
            body.style.top = `-${scrollY}`;
            body.style.overflow = 'hidden';
            content.style.height = '100%';

            // Check if Sticky Buttons and the ID plp-products-contents exist
            if($(stickyButtons).length && $(plpProductsContents).length) {
              if(parseInt(scrollY) > plpProductsContentsOffsetTop) {
                  stickyButtons.classList.add('persisitScrolled');
              }
            }
        }

    }
    richNav();
    // UX-13654 - Rich Nav - End

    // UX-13654 - Sticky Buttons - Hide/Show
    function stickyButtons() {
        const stickyButtons = document.querySelector(".js-sticky-buttons");
        const stickyButtonsIcon = document.querySelector(".js-sticky-buttons__icon");
        const plpProductsContents = document.getElementById('plp-products-contents');

        // Check if Sticky Buttons and the ID plp-products-contents exist
        if($(stickyButtons).length && $(plpProductsContents).length) {
            // Add click event to sticky buttons icon to scroll to Visual Nav
            if($(stickyButtonsIcon).length) {
                const visNav = document.querySelector(".js-visual-nav");
                const visNavOffsetTop = visNav.offsetTop;
                $(stickyButtonsIcon).on("click", function(){
                    $('html, body').animate({ scrollTop: visNavOffsetTop }, 300 );
                });
            }

            // Check window position to show Sticky Buttons
            window.addEventListener('scroll', () => {
                let scrollPos = $(this).scrollTop();
                const plpProductsContentsOffsetTop = plpProductsContents.offsetTop;
                if (scrollPos > plpProductsContentsOffsetTop) {
                    stickyButtons.classList.add('scrolled');
                } else {
                    stickyButtons.classList.remove('scrolled');
                }
            });
        }
    }
    stickyButtons();
    // UX-13654 - Sticky Buttons - End

    initCplBanner();

    if (window.rcProps.revieveEventEnabled) {
        revieveTryOn({
            isPlp: true,
            checkAvailability: true,
        });
    } else {
        $(window).on('revieveScriptLoaded', function () {
            revieveTryOn({
                isPlp: true,
                checkAvailability: true,
            });
        });
    }
    revieveMakeupAdvisor();
    revieveAddToBag();
    renderPlpSocialProof($('.js-plp-container').toArray().map((el) => $(el).prop('id')));

    function toggleButtonState($button, isActive, activeClasses, inactiveClasses) {
        const activeText = $button.data('active-text');
        const inactiveText = $button.data('inactive-text');
        if (!isActive) {
          // Change to active state
          $button.addClass('is-active');
          $button.removeClass(inactiveClasses).addClass(activeClasses);
          $button.find('.js-toggle-icon-heart').addClass('u-hide');
          $button.find('.js-toggle-icon').removeClass('u-hide');
          $button.find('.js-button-text-target').text(activeText);
          $button.data('is-active', true);
        } else {
          // Revert back to inactive state
          $button.removeClass('is-active');
          $button.removeClass(activeClasses).addClass(inactiveClasses);
          $button.find('.js-toggle-icon').addClass('u-hide');
          $button.find('.js-toggle-icon-heart').removeClass('u-hide');
          $button.find('.js-button-text-target').text(inactiveText);
          $button.data('is-active', false);
        }
    }

    window.favoriteDesignerTrigger = function () {
        $(document)
            .off('click.textSwitch', '.js-text-switch-trigger')
            .on('click.textSwitch', '.js-text-switch-trigger', function () {
            const isActive = $(this).data('is-active');
            if ($(this).hasClass('js-action-button-target')) {
                toggleButtonState($(this), isActive, '', 'action-button--dark');
            } else {
                toggleButtonState($(this), isActive, 'pill-button--white-blk-stroke', 'pill-button--black');
            }
        });
    }
    favoriteDesignerTrigger()
});



document.addEventListener('zeligWidgetLoaded', function(e) {
    window.rcProps.zeligWidgetLoaded = true;
    $('.js-zelig-try-on').removeClass('u-hide');
});

document.addEventListener('WidgetModalOpen', function(e) {
    logEngagement(window.location.href, 'Zelig', 'PLP widget clicks');
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/index.js